<template>
  <CollectionGroup :items="collectionItems" />
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import CollectionGroup from '@/components/CollectionGroup.vue'

export default Vue.extend({
  name: 'CollectionGroupHost',
  components: {
    CollectionGroup
  },
  props: {
    configurations: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    collectionItems: function () {
      return this.collections().map((value, index) => {
        return {
          id: value.id,
          title: value.name,
          imageUrl: value.banner
        }
      })
    }
  },
  mounted () {
    if (this.collectionItems.length === 0) {
      this.loadCollections()
    }
  },
  methods: {
    ...mapActions({
      loadCollections: 'productCatalog/loadCollections'
    }),
    ...mapGetters({
      collections: 'productCatalog/collections'
    })
  }
})
</script>
